"use client";

import { RenderIf, Slider } from "@repo/ui";
import Section from "../components/Section";
import CourseCard from "../components/CourseCard";
import { hasData } from "@/lib/helpers";
import moment from "moment";
import usePosts from "@/hooks/usePosts";
import Loading from "@/components/common/Loading";

type BlogSliderProps = {
  data: Post[];
};

const BlogSlider = ({ data }: BlogSliderProps) => (
  <Slider
    id="gain-some-knowledge-slider"
    removeContainerPadding={false}
    removeSliderPadding={true}
    options={{
      breakpoints: {
        "0": {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        "640": {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        "768": {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        "1024": {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        "1170": {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
      navigation: {
        enabled: true,
      },
      pagination: {
        clickable: true,
      },
      slidesPerGroup: 3,
      slidesPerView: 3,
      spaceBetween: 24,
    }}
    navigationCentered
    navigationCenteredInner={false}
    hideNavigation
  >
    {data.map((post, idx) => (
      <CourseCard
        key={idx}
        isAuthor
        title={post.title}
        slug={`${process.env.NEXT_PUBLIC_APP_URL}/blog/${post.slug}`}
        coverSrc={post.feature_image.medium}
        description={post.content}
        author={post.author}
        date={moment(post.created_on).format("DD MMM YYYY")}
        readingDuration="20 Minutes read"
      />
    ))}
  </Slider>
);

type GainSomeKnowledgeProps = {
  sectionInfo: PageSections;
  data?: {
    heading: string;
    buttonText: string;
    buttonAction: string;
  };
};

const GainSomeKnowledge = ({ data, sectionInfo }: GainSomeKnowledgeProps) => {
  const { posts, loading } = usePosts();

  if (!hasData(data)) return null;

  return (
    <Section
      title={data?.heading}
      path={"/blog"}
      actionLabel={"Explore Knowledge Hub"}
      id={sectionInfo.sectionId}
      className={`${sectionInfo.sectionClass} bg-gradient-to-b from-blue-50 to-white`}
    >
      <RenderIf
        condition={!loading && !!data}
        fallback={<Loading message="Posts Loading..." />}
      >
        <BlogSlider data={posts || []} />
      </RenderIf>
    </Section>
  );
};

export default GainSomeKnowledge;
